<template>
    <div class="row">
        <TitleComponent class="col-12" title="1. Selecciona tu asiento" subtitle="Si lo deseas, también puedes escoger varios asientos a la vez" />
        <ContentOrLoading class="col-12">
            <template v-if="!loading">
                <div class="row h-100">
                    <div class="lightgray-content p-0 col-12 col-md-8">
                        <RecintoAnexoComponent
                            v-if="plazas"
                            class="col-12"
                            :region_id="zona.id"
                            :plazas="plazas"
                            :plazasSeleccionadas="[]"
                            :continuarConCompra="continuarConCompra"
                            :tipo_svg="parseInt(zona.tipo_svg, 10)"
                            :precios="precios"
                            @clickZona="clickZona"
                        />
                    </div>
                    <div class="col-12 col-md-4 mt-3 mt-md-0">
                        <div class="text-center">
                            <h3>TUS ASIENTOS</h3>
                        </div>
                        <div class="col-12 text-center" v-if="datos_compradores && datos_compradores.length === 0">
                            <p>Seleccione los asientos para continuar</p>
                        </div>
                        <template v-else>
                            <div>
                                <div v-for="(asiento, index) in datos_compradores" :key="index">
                                    <div v-if="asiento.butaca" class="col-12 bg-secondary mb-2 p-2" >
                                        {{ ++index }}. {{ asiento.nombre_sector ? ('Sector: ' + asiento.nombre_sector + ' - ') : '' }}
                                        <span>
                                            Fila: {{ asiento.fila }} - Butaca: {{ asiento.butaca }}
                                        </span>
                                    </div>
                                    <div v-if="asiento.numero" class="col-12 bg-secondary mb-2 p-2">
                                        {{ ++index }}. Plaza: {{ asiento.numero }}

                                    </div>
                                </div>
                            </div>
                            <button class="btn btn-block" @click="bloquearButacas">Continuar</button>
                        </template>
                    </div>

                </div>
            </template>
        </ContentOrLoading>
    </div>
</template>

<script>
import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
import RecintoAnexoComponent from '@/components/svg/RecintoAnexoComponent';


export default {
    props: ['zona', 'datos_compradores', 'precios', 'continuarConCompra', 'recinto'],
    created() {
        if (this.recinto) {
            this.getPlazas();
        }
    },
    data() {
        return {
            loading: false,
            plazas: null
        }
    },
    methods: {
        clickZona(plazaSeleccionada) {
            this.plazas.find(plaza => {
                if (plaza.id == plazaSeleccionada.id) {
                    plaza.seleccionada = plaza?.seleccionada && plaza.seleccionada ? false : true;
                    if (plaza.seleccionada) {
                        this.datos_compradores.push(plaza)
                    } else {
                        const index = this.datos_compradores.findIndex(plaza => plaza.id == plazaSeleccionada.id);
                        
                        if (index !== -1) {
                            this.datos_compradores.splice(index, 1);
                        }
                    }                    
                }
            })
        },
        bloquearButacas() {
            const data = this.datos_compradores.map(plaza => {
                return { plazaId: plaza.id }
            });

            const params = {
                filters: {},
                event_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                zona_id: this.zona.id,
                data: data
            }

            this.$store.dispatch(this.config.getVuexAlias('back.event.sesiones.zonas.taquilla.bloquear-plazas'), params)
                .then(({ data }) => {
                    sessionStorage.setItem('session_id', data.session_id);
                    this.$emit('goTo', 3, this.datos_compradores, data.session_id);
                })
                .catch(() => {
                    this.$toast.error('Butaca/s ocupada/s');
                });
        },
        getPlazas() {
            this.loading = true;
            const params = {
                filters: {},
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                recinto_id: this.recinto.id,
                region_id: this.zona.id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.taquilla.recinto.zonas-anexas.butacas'), params).then(res => {
                this.plazas = res.data.data;
            }).catch(() => {
                console.warn('Ha ocurrido un error recuperando las plazas');
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    components: { TitleComponent, RecintoAnexoComponent }
}
</script>